import { Injectable } from '@angular/core';
import { splitScriptsFromLayout } from '@mode/shared/util-js';
import { Store } from '@ngrx/store';
import { BehaviorSubject, map } from 'rxjs';
import { LayoutSelectors } from './embed-layout.selectors';

@Injectable({
  providedIn: 'root',
})
export class EmbedLayoutFacade {
  private initialLayout$ = new BehaviorSubject<string | null>(null);
  private fragmentAndScriptLoader$ = this.initialLayout$.pipe(
    map((layout) => splitScriptsFromLayout(this.window.document.head, layout))
  );

  initialLayoutFragment$ = this.fragmentAndScriptLoader$.pipe(map(({ fragment }) => fragment));
  initialScripts$ = this.fragmentAndScriptLoader$.pipe(map(({ scripts }) => scripts));

  parsedLayout$ = this.store.select(LayoutSelectors.parsedLayout);
  hasCustomStyle$ = this.store.select(LayoutSelectors.hasCustomStyle);
  hasCustomScripts$ = this.store.select(LayoutSelectors.hasCustomScripts);
  disableVirtualScroll$ = this.store.select(LayoutSelectors.disableVirtualScroll);

  constructor(
    private window: Window,
    private store: Store
  ) {}

  // Ideally this would actually come from the store, but the builder currently does not
  // push the initial state into the store.
  setInitialLayout(layout: string) {
    this.initialLayout$.next(layout);
  }
}
